module.exports = __webpack_public_path__ + "img/vehicleTypes.302ed7ba.svg";